<template>
  <button
    :disabled="lineItems.length === 0"
    class="bg-br-green font-medium hover:text-white flex items-center justify-center w-full h-12 text-center text-white transition-all rounded-full shadow-lg"
    @click="handleCheckout"
  >
    {{ $t('cart.checkOut') }}
  </button>
</template>

<script setup>
import { useCartStore } from '@/stores/cart';
import { storeToRefs } from 'pinia';

const cartStore = useCartStore();
const { lineItems } = storeToRefs(cartStore);

const handleCheckout = async () => {
  const url = await cartStore.checkoutUrl();

  if (url) {
    window.open(url, '_self');
  }
};
</script>
